<template>
    <div class="form-group_up">
        <label class="form-label" for="name-f">Пошук</label>
        <div class="input-group">
            <div class="input-group-prepend">
                <span class="input-group-text border-right-0">
                    <i class="fal fa-democrat"></i>
                </span>
            </div>
            
            <input type="text" v-model="search_txt" id="filter_search" class="form-control" placeholder="Пошук"/>
            
            <div class="input-group-append srch">
                <button class="btn btn-primary shadow-0 waves-effect waves-themed" @click="send_search">
                    <i class="fal fa-search"></i>
                </button>
                <button type="button" class="btn btn-outline-primary shadow-0 waves-effect waves-themed"
                        data-toggle="collapse"
                        data-target="#collapseFilter"
                        aria-controls="collapseFilter"
                        aria-expanded="true"
                >
                    Фільтр
                </button>
                <button type="button" class="btn btn-danger shadow-0 waves-effect waves-themed" @click="clear_form">
                    <span class="fal fa-times mr-1"></span>
                    Очистити
                </button>
            </div>
        </div>
        
        <div class="frame-wrap mt-3 mb-0 w-100">
            <div
                class="collapse"
                :class="{ show: !!localFilter.owner || !!localFilter.status}"
                id="collapseFilter" >
                <div class="card card-body row">
                    <div class="row">
                        <v-select
                            label="text"
                            :options="multi_users"
                            v-model="localFilter.owner"
                            :reduce="owner => owner.value"
                            class="col-sm-6 mt-2"
                            placeholder="Створив"
                            @update:modelValue="search"
                        ></v-select>
                        
                        
                        <v-select
                            label="text"
                            :options="liststatus"
                            v-model="localFilter.status"
                            :reduce="status => status.value"
                            placeholder="Статус"
                            class="col-sm-6 mt-2"
                            @update:modelValue="search"
                        ></v-select>
                    </div>
                
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import vSelect from 'vue-select';
export default {
    name: "tender_filter",
    emits: ["update:filter", "search_called", "clean_filter"],
    props: {
        searchValue: {
            type: String,
            default: ''
        },
        
        filter: {
            type: Object,
            default: () => ({
                status: "",
                owner : "",
            }),
        },
    },
    
    components:  {
        vSelect
    },
    
    data() {
        return {
            search_txt: this.searchValue,
            multi_users: [],
            liststatus:    [
                {"value":"new", "text":"Новий"},
                {"value":"published", "text":"Опублікований"},
                {"value":"archive", "text":"Архів"}
            ],
        };
    },
    
    mounted() {
        this.loadOwners();
    },
    
    methods: {
        
        async loadOwners() {
            try {
                const { data } = await api.post("/tenders/sales/tenders/helpers/owners");
                this.multi_users = data.status === "operation_success" ? data.data : [];
            } catch (e) {
                this.multi_users = [];
            }
        },
        
        
        search() {
            this.$emit("search_called", this.search_txt);
        },
        
        send_search() {
            this.$emit("search_called", this.search_txt);
        },
        
        clear_form() {
            this.search_txt = "";
            this.$emit("clean_filter");
        },
    },
    
    computed: {
        localFilter: {
            get() {
                return this.filter;
            },
            set(v) {
                this.$emit("update:filter", v);
            },
        },
    },
    
};
</script>

<style scoped>
</style>
